import React, { useEffect, useState } from "react";
import { Modal, Form, Input, DatePicker, message, Select } from "antd";
import { platformApi } from "../../../../../../api";

const { Item } = Form;
const { Option } = Select;

const AddReceipt = ({
  visible,
  onCancel,
  orderId,
  onSuccess,
  form,
  selectedData,
}) => {
  const { getFieldDecorator } = form;
  const [suppliers, setSuppliers] = useState([]);
  useEffect(() => {
    getSuppliers();
  }, []);

  const getSuppliers = async () => {
    try {
      const response = await platformApi.get("/api/supplier");
      setSuppliers(response.data.response.data);
    } catch (error) {
      console.error("Error fetching suppliers:", error);
      message.error("Failed to load suppliers");
    }
  };

  const handleSubmit = () => {
    form.validateFields((err, values) => {
      if (!err) {
        const data = {
          receiveDate: values.receiveDate.format("DD-MM-YYYY"),
          // receivedPartNo: values.receivedPartNo,
          receivedPartNo: selectedData?.orderedPartNo?.id || selectedData?.orderedPartNo,
          receivedPartName: values.receivedPartName,
          receivedQuantity: parseInt(values.receivedQuantity, 10),
          billNo: values.billNo,
          supplierId: values.supplierId,
        };

        platformApi
          .post(
            `/api/customerSpareOrderRouter/addPartOrderReceipt/${orderId}`,
            data
          )
          .then(() => {
            message.success("Receipt added successfully");
            form.resetFields();
            onSuccess();
          })
          .catch((error) => {
            console.error(error);
            message.error("Failed to add receipt");
          });
      }
    });
  };

  return (
    <Modal
      title="Add Receipt"
      visible={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      okText="Save"
    >
      <Form layout="vertical">
        <Item label="Received Part Number" required>
          {getFieldDecorator("receivedPartNo", {
            rules: [{ required: true, message: "Please input part number!" }],
            initialValue: selectedData?.orderedPartNo?.partNumber,
          })(<Input />)}
        </Item>
        <Item label="Receieved Part Name" required>
          {getFieldDecorator("receivedPartName", {
            rules: [{ required: true, message: "Please input part name!" }],
            initialValue: selectedData?.orderedPartNo?.partName,
          })(<Input />)}
        </Item>
        <Item label="Receive Date" required>
          {getFieldDecorator("receiveDate", {
            rules: [{ required: true, message: "Please input receive date!" }],
          })(
            <DatePicker
              style={{ width: "100%" }}
              format="DD-MM-YYYY"
              placeholder="Select date"
            />
          )}
        </Item>
        <Item label="Quantity" required>
          {getFieldDecorator("receivedQuantity", {
            rules: [
              { required: true, message: "Please input quantity!" },
              {
                validator: (rule, value, callback) => {
                  if (value !== undefined && value !== null && value !== "") {
                    const num = Number(value);
                    if (isNaN(num) || num <= 0 || !Number.isInteger(num)) {
                      callback("Quantity must be a positive integer!");
                      return;
                    }
                  }
                  callback();
                },
              },
            ],
          })(
            <Input
              type="text"
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) e.preventDefault();
              }}
              placeholder="Quantity"
            />
          )}
        </Item>
        <Item label="Bill No" required>
          {getFieldDecorator("billNo", {
            rules: [{ required: true, message: "Please input bill number!" }],
          })(<Input />)}
        </Item>
        <Item label="Supplier" required>
          {getFieldDecorator("supplierId", {
            rules: [{ required: true, message: "Please select supplier!" }],
          })(
            <Select placeholder="Select supplier">
              {suppliers.map((supplier) => (
                <Option key={supplier.id} value={supplier.id}>
                  {supplier.name}
                </Option>
              ))}
            </Select>
          )}
        </Item>
      </Form>
    </Modal>
  );
};

export default Form.create()(AddReceipt);
